/* helper */
import Helper from "./helpers";

export default class Api {
    static async fetch({
        url,
        params,
        method,
        baseUrl = null,
        headers  = {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        }
    }) {
        /* Process options */
       const options = {
        method : method,
        headers : {
            Authorization : `Bearer ${Helper.getCookie('springstoken')}`,
            ...headers
        }
       }

        /* 
            Process params
        */
       const baseurl   = baseUrl ? baseUrl : process.env.VUE_APP_STAKEAPIBASEURL
       const newparams = new FormData()

       if(params) {
            for (const key in params) {
                const value = params[key];

                newparams.append(key, value)
            }

            options.body = JSON.stringify(params)
       }

        // Process call
        const res = await fetch(`${baseurl}/${url}`, options)

        // Check if response is ok
        if (!res.ok) {
            console.error(`API Error: ${res.status} - ${res.statusText}`)
            return null
        }

        // Check if response has content
        const text = await res.text()
        
        // If empty response, return null
        if (!text) {
            console.warn(`Empty response from ${url}`)
            return null
        }

        // Try to parse JSON
        try {
            return JSON.parse(text)
        } catch (error) {
            console.error(`Failed to parse JSON response from ${url}:`, text)
            return null
        }
    }
}